import React from "react";

import "./inlineWhisper.scss";

const InlineWhisper = ({
  isInline,
  whisper = "",
  site = "hl",
  sponsorImageUrl,
  sponsorUrl,
}) => {
  return (
    <div className={`whisper ${site}`}>
      {isInline ? whisper.toUpperCase() : null}
      {isInline && sponsorImageUrl && (
        <div className="sponsor">
          <span className="sponsor-text">Sponsored by</span>
          <a href={sponsorUrl}>
          <div
            className="sponsor-image"
            style={{ backgroundImage: `url(${sponsorImageUrl})` }}
          />
          </a>
        </div>
     
      )}
    </div>
  );
};

export default InlineWhisper;
